import { Text, Img } from "./..";
import React from "react";

const Footer = ({ ...props }) =>  {
  return (
    <footer {...props} className={`${props.className} flex items-center p-10 sm:p-5 bg-indigo-A200`}>
      <div className="mx-auto mb-[35px] mt-10 flex w-full max-w-[1360px] items-center justify-between gap-5 md:flex-col">
        <div className="flex w-[38%] flex-col items-start gap-1.5 md:w-full">
          <Img src="images/img_logo.svg" alt="logo" className="h-[40px] w-full md:h-auto" />
          <Text size="textmd" as="p" className="!font-dmsans text-lg font-normal text-white-A700">
            Copyright © 2024 Brincus.com
          </Text>
        </div>
        <Text size="textmd" as="p" className="flex !font-dmsans text-lg font-normal">
          <span className="text-white-A700">Todos los derechos reservados |&nbsp;</span>
          <a href="#" className="text-white-A700 underline">
            Términos y condiciones
          </a>
        </Text>
      </div>
    </footer>
  );
}

export { Footer };